<div class="row kpi"
     [stepContent]="kpisStepContent"
     joyrideStep="kpisStep">
    <div class="col-md-12 p-0">
        <div class="row">
            <div [ngClass]="'col-6 col-lg-' + length + ' kpi-' + kpi" *ngFor="let kpi of kpis">
                <ng-template appAdKpi>{{ kpi }}</ng-template>
            </div>
        </div>
    </div>
</div>

<ng-template #kpisStepContent>
    <div class="user_onboarding_content">
        <h2>Comment fonctionnent les onglets ?</h2>
        <p>
            Chaque onglet est divisé en deux parties :<br/>
            <br/>
            Une première avec <b>les indicateurs clés en couleurs</b>, qui vous permettent en quelques secondes d’avoir les bonnes informations<br/>
            <br/>
            Ces indicateurs se <b>recalculent instantanément</b> lorsque vous modifiez des informations dans l'annonce.
        </p>
    </div>
</ng-template>
